import { render, staticRenderFns } from "./UserRoleDialog.vue?vue&type=template&id=b8de4a08&scoped=true"
import script from "./UserRoleDialog.vue?vue&type=script&lang=js"
export * from "./UserRoleDialog.vue?vue&type=script&lang=js"
import style0 from "./UserRoleDialog.vue?vue&type=style&index=0&id=b8de4a08&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8de4a08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8de4a08')) {
      api.createRecord('b8de4a08', component.options)
    } else {
      api.reload('b8de4a08', component.options)
    }
    module.hot.accept("./UserRoleDialog.vue?vue&type=template&id=b8de4a08&scoped=true", function () {
      api.rerender('b8de4a08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/components/UserRoleDialog.vue"
export default component.exports